import FieldsCollection from "../../../../../fields3/collection/base/fields-collection"
import {FieldType} from "../../../../../fields3/field-type"

export default function ProjectUser_initWorkspaceUserFields(projectId: ID) {
    return new FieldsCollection([
        {
            fieldId : 'access',
            type    : FieldType.WORKSPACE_ACCESS,
        },
        {
            fieldId : 'watchAll',
            type    : FieldType.TOGGLE
        },
    ])
}